export const passwordApi = {
  resetPassword: (id: string): string =>
    `/api/admin/users/${id}/reset-password`,
  checkPassword: (): string => `/api/portal/users/me/check-password`,
  changePassword: (): string => `/api/portal/users/me/password`,
};
